import Signature from './AbstractSignature';
import { CreateElement, VNode } from 'vue';
import { ChildParams, referencesMethod } from '@/templates/References';

export default function NodejsSignatureFactory(kind: string) {
  switch (kind) {
    case 'method':
      return NodejsMethodSignature;
    case 'prop':
      return NodejsPropertySignature;
    case 'const':
      return NodejsPropertySignature;
    case 'function':
      return NodejsMethodSignature;
    case 'typedef':
      return NodejsPropertySignature;
    case 'api_field':
      return NodejsFieldSignature;
    default:
      return {
        getSignature(_method: any): null {
          return null;
        },
      };
  }
}

class NodejsMethodSignature extends Signature {
  public static LANG = 'nodejs';

  public static getSignature(method: referencesMethod): (h: CreateElement) => VNode {
    const returnsType = this.returnsType(method.returns);
    const paramSignatures = this.paramSignatures(method.params);

    return (h) =>
      h('code', [
        h('span', { class: 'token function' }, `${method.title}`),
        h('span', { class: 'token punctuation' }, '('),
        paramSignatures(h),
        h('span', { class: 'token punctuation' }, ')'),
        h('span', { class: 'token punctuation' }, ': '),
        returnsType(h),
      ]);
  }

  private static paramSignatures(paramSignatures: ChildParams[]): (h: CreateElement) => VNode {
    if (!paramSignatures) return (h) => h();

    return (h) =>
      h(
        'span',
        paramSignatures.map((val: ChildParams, idx: number) => {
          return h('span', [
            `${val.title}`,
            h('span', { class: 'token punctuation' }, ': '),
            val.types ? this.returnsType(val.types)(h) : '',
            !(idx === paramSignatures.length - 1)
              ? h('span', { class: 'token punctuation' }, ', ')
              : '',
          ]);
        })
      );
  }
}

class NodejsPropertySignature extends Signature {
  public static LANG = 'nodejs';

  //TODO сделать тип для property
  public static getSignature(property: any): (h: CreateElement) => VNode {
    return (h) =>
      h('code', [
        `${property.title}`,
        h('span', { class: 'token punctuation' }, ': '),
        property.types ? this.returnsType(property.types)(h) : '',
      ]);
  }
}

class NodejsFieldSignature extends Signature {
  public static LANG = 'nodejs';

  public static getSignature(field: any): (h: CreateElement) => VNode {
    return (h) =>
      h('code', [
        `${field.title}`,
        h('span', { class: 'token punctuation' }, ': '),
        field.type
          ? h('span', {
              class: 'token type md-parse',
              domProps: { innerHTML: `${this.convertToHtml(field.type)}` },
            })
          : '',
      ]);
  }
}
